import { useContext } from 'react';
import { AppConfigContext } from '../contexts/AppConfigContext';

// ----------------------------------------------------------------------

const useAppConfig = () => useContext(AppConfigContext);

export default useAppConfig;
